export default __webpack_public_path__ + "static/media/Punjabi_Kada.065d32f5.jpg";